import results from "./results"
import geojson from "./geojson"

export default {
  geojson,
  results
};
